export const LayoutFooter = ({ children }) => (
  <footer>
    <div className="container spaceBetween">{children}</div>
  </footer>
);
